
const { mapGetters } = require('vuex')

export default {
  computed: {
    ...mapGetters(['canContribDep'])
  }
}
